import { ApplicationInsights } from '@microsoft/applicationinsights-web';

export const appInsights = new ApplicationInsights({
    config: {
        //TODO: move the key to the backend config file if dont want Norbi's anger.
        instrumentationKey: 'b250a7a6-f32f-4331-8aa7-671b52c8e018'
    }
});

export const hasSentDailyLog = () => {
    const lastSentDate = localStorage.getItem('lastDailyLogDate');
    const currentDate = new Date().toISOString().split('T')[0];
    return lastSentDate === currentDate;
};

export const updateLastSentDate = () => {
    const currentDate = new Date().toISOString().split('T')[0];
    localStorage.setItem('lastDailyLogDate', currentDate);
};